import { backendFetch, backendPatch } from '@/common/api';
import { objectToFormData } from '@/common/utilities/objectToFormData.ts';

// Constants matching backend NotificationSubscription model
export const NOTIFICATION_TYPES = {
  PATIENT_REFERRAL: 'patient_referral',
} as const;

export const CHANNELS = {
  EMAIL: 'email',
} as const;

export interface NotificationSubscriptionGroup {
  notificationType: string;
  channel: string;
  userIds: number[];
}

export interface UpdateNotificationSubscriptionsData {
  notificationType: string;
  channel: string;
  userIds: number[];
}

export async function loadNotificationSubscriptions(): Promise<
  NotificationSubscriptionGroup[]
> {
  return backendFetch<NotificationSubscriptionGroup[]>(
    '/portal/notification_subscriptions',
    {
      credentials: 'include',
    }
  );
}

export async function updateNotificationSubscriptions(
  data: UpdateNotificationSubscriptionsData
): Promise<void> {
  const formData = objectToFormData({ ...data });

  return backendPatch<void>('/portal/notification_subscriptions', formData, {
    credentials: 'include',
  });
}
